<template>
  <div class="noticeDetails">
    <div class="noticeDetails_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">详情</div>
    </div>
    <div class="noticeDetails_bottom">
      <div class="noticeDetails_bottom_list">
        <p
          style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
        >
          {{ details_list.title }}
        </p>
        <div>
          <span>{{ details_list.createTime }}</span>
        </div>
        <p
          style="
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          "
          v-html="details_list.content"
        ></p>
        <p
          style="
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          "
        >
          {{ details_list.createName }}
        </p>
        <p
          style="
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-bottom: 50px;
          "
        >
          {{ details_list.updateTime }}
        </p>
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "noticeDetails",
  data() {
    return {
      id: "",
      details_list: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.detailList();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    async detailList() {
      let res = await this.$apis.myServe.detailList({ id: this.id });
      this.details_list = res.data;
      console.log(res);
    },
  },
};
</script>
    
    <style lang="scss" scoped>
.noticeDetails {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  .noticeDetails_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 72px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }
  .noticeDetails_bottom {
    width: 100%;
    height: 100%;
    margin-top: 13px;
    .noticeDetails_bottom_list {
      width: 94%;
      background: #fff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      margin-left: 12px;
      overflow: hidden;
      p {
        font-size: 16px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        color: #333333;
        margin-left: 20px;
        margin-top: 21px;
      }
      div {
        margin-top: 7px;
        span {
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          margin-left: 20px;
        }
      }
      .content {
        margin-left: 20px;
        margin-top: 21px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }
  }
}
</style>